import { render, staticRenderFns } from "./AddCompanyModal.vue?vue&type=template&id=21774222&"
import script from "./AddCompanyModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyModal.vue?vue&type=style&index=0&id=21774222&prod&lang=less&none=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports